/** @prettier */
import { batchEventUpdate } from '@xanadu/ui-shared/modules/event/actions';

import { all, call, put, select, takeEvery } from 'redux-saga/effects';

import { REQUEST_RELATED_EVENTS, setRelatedEvents } from './actions';
import * as api from './api';

const REQUEST_THRESHOLD = 100;

const REQUESTS_TIMINGS = new Map();

function* handleFetchRequests({ payload }) {
  const { competition, eventId: parentEventId } = payload;

  if (!competition) return;

  const product = yield select((state) => state.getIn(['application', 'product']));

  const previousTime = REQUESTS_TIMINGS.get(competition);
  const now = Date.now();

  if (!previousTime || (previousTime && now > previousTime + REQUEST_THRESHOLD)) {
    REQUESTS_TIMINGS.set(competition, now);
    const { entities } = yield call(api.fetchRelatedEvents, { competition, product });
    const events = Object.values(entities.events || {});

    // NOTE: This is done to enable smoother page transitions. We receive the data anyway, might as well
    //       add it to the store
    yield put(setRelatedEvents(competition, events));

    if (events.length > 1) {
      const otherEvents = events.filter((event) => event.id !== parentEventId);

      yield put(batchEventUpdate(otherEvents));
    }
  }
}

export default function* root() {
  yield all([takeEvery(REQUEST_RELATED_EVENTS, handleFetchRequests)]);
}
